import { ContentControlledLinkedFileMediaTypeEnum } from '../enums/content-controlled-linked-file-media-type.enum';

export class ContentControlItemLinkedFile {
  constructor(
    public fileType: ContentControlledLinkedFileMediaTypeEnum,
    public language: string,
    public url: string,
    public name: string,
    public fps: number,
    public offset: number,
    public playbackSpeed: number,
  ) {}
}
